import { ActionType } from '../constants/ActionTypes';
import { RestPath } from '../constants/SitePaths';
import axios from 'axios';
import Constants from '../constants/Constants';
import config from '../constants/Configs';
import { Browser } from '../services/helpers/Browser';
import { Auth } from '../services/Auth';
import { LanguageService } from '../services/LanguageService';

// Get Page
export const getStoriesBegin = () => ({
  type: ActionType.GET_STORIES_BEGIN
});

export const getStoriesSuccess = data => ({
  type: ActionType.GET_STORIES_SUCCESS,
  payload: data
});

export const resetStories = () => ({
  type: ActionType.RESET_STORIES
})

export const getStoriesError = (error) => ({
  type: ActionType.GET_STORIES_ERROR,
  payload: error
});

export function getStories(alias, type, params = {}) {

  const a = Auth.isAuthenticated();
  const l = LanguageService.getSelectedLanguage();
  const d = Browser.getHeaderDeviceType();

  params = { ...params, alias, a, l, d };

  const p = Browser.getMobilePlatform();
  if (p) params.p = p;

  return dispatch => {
    dispatch(getStoriesBegin());
    return axios({
      method: Constants.GET,
      url: config.BASE_URL + RestPath.GET_STORIES,
      params: params
    }).then((response) => {
      dispatch(getStoriesSuccess({ type, data: response.data, pageName: params.alias }));
    }).catch((error) => {
        if (error.response) {
          dispatch(getStoriesError(error.response.data));
        } else {
          dispatch(getStoriesError(error));
        }
      });
  };
}
